import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateRejectionRequest {
  @observable
  rejectionReason!: string;
}

export const CustomerRefundCandidateRejectionRequestValidationRules: EntityValidationRules<CustomerRefundCandidateRejectionRequest> =
  {
    rejectionReason: {
      required: true,
      isLength: {
        max: 160,
      },
    },
  };
